import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {useCustomerContext} from "../../customer/CustomerContextProvider/CustomerContextProvider";
import ListLoader from "../../utils/loader/ListLoader";
import {Button, ButtonStyles} from "../form/Button/Button";
import window from "../WindowExtended";
import {validateEmail} from "./ForgotPasswordModal";
import Modal from "./Modal";

interface IMagicLinkModalProps {
  closeFunction: () => void;
  isVisible: boolean;
}
const MagicLinkModal: React.FC<IMagicLinkModalProps> = (props) => {
  const {t} = useTranslation("checkout");
  const {customer} = useCustomerContext();
  const [{emailSent, error, sendingEmail}, setEmailState] = useState<{
    emailSent: boolean;
    error: boolean;
    sendingEmail: boolean;
  }>({
    emailSent: false,
    error: false,
    sendingEmail: false,
  });

  const {origin, pathname, search} = window.location;
  const usp = new URLSearchParams(search);

  usp.set("gotoStep", "magicLink");
  const redirectUrl = origin + pathname + "?" + usp.toString();

  useEffect(() => {
    if (customer.email && props.isVisible) {
      setEmailState((prevState) => ({...prevState, sendingEmail: true}));
      void customer.requestMagicLink(customer.email, redirectUrl).then(() => {
        setEmailState({emailSent: true, error: false, sendingEmail: false});
      });
    }
  }, [props.isVisible]);

  const resetter = () => {
    setEmailState({emailSent: false, error: false, sendingEmail: false});
    props.closeFunction();
  };

  if (sendingEmail) {
    return (
      <Modal isVisible={props.isVisible} closeFunction={props.closeFunction}>
        <br />
        <ListLoader />
      </Modal>
    );
  }
  const EmailSent: React.FC = () => (
    <React.Fragment>
      <h2>{t("Bitte prüfen Sie Ihren Posteingang")}</h2>
      <p className="content">{t("Wir haben Ihnen eine E-Mail mit einem Login-Link gesendet. ...")}</p>
      <div className="center">
        <Button styles={[ButtonStyles.big]} action={resetter}>
          {t("Okay")}
        </Button>
      </div>
    </React.Fragment>
  );

  const EnterEmail: React.FC = () => {
    const [email, setEmail] = useState<string>();
    const [validEmail, setValidEmail] = useState<boolean>(true);

    const sendEmail = async (evt: React.FormEvent) => {
      evt.preventDefault();
      try {
        if (email && validateEmail(email)) {
          setValidEmail(true);
          setEmailState(() => ({emailSent: false, error: false, sendingEmail: true}));
          await customer.requestMagicLink(email, redirectUrl);
          setEmailState({emailSent: true, error: false, sendingEmail: false});
        } else {
          setValidEmail(false);
        }
      } catch (e) {
        setEmailState({emailSent: false, error: true, sendingEmail: false});
      }
    };

    if (emailSent) {
      return <EmailSent />;
    }

    return (
      <React.Fragment>
        <h2>{t("Sie sind bereits Kunde bei uns")}</h2>
        <p className="content">{t("Überspringen Sie die Dateneingabe ...")}</p>
        {error && (
          <p style={{color: "red"}}>
            {t("Bei der Übertragung ist ein Fehler aufgetreten. Bitte versuchen Sie es noch einmal.")}
          </p>
        )}
        {!validEmail && <span style={{color: "red"}}>{t("Die eingegebene E-Mail-Adresse ist nicht gültig.")}</span>}
        <form style={{margin: "16px 0"}} onSubmit={(evt: React.FormEvent) => sendEmail(evt)}>
          <input
            style={{marginBottom: "16px", display: "block"}}
            type="email"
            placeholder={t("Ihre E-Mail-Adresse *")}
            onChange={(e) => setEmail(e.target.value.trim())}
          />
          <Button styles={[ButtonStyles.big]}>{t("Login-Link generieren")}</Button>
        </form>
      </React.Fragment>
    );
  };

  return (
    <Modal isVisible={props.isVisible} closeFunction={resetter}>
      <EnterEmail />
    </Modal>
  );
};

export default MagicLinkModal;
